import { FormikInsurance, Gender, Nationality, YesNoAnswersNew } from "src/types";
import { useNaturalContractorSummary } from "./natural-contractor-summary.hook";

export const NaturalContractorSummary = ({
  insurance,
}: {
  insurance: FormikInsurance;
}) => {
  const { naturalContractor, t } = useNaturalContractorSummary({ insurance });

  return (
    <div className="col-12">
      <div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_name")}
            </div>
            <div className="font-16">{naturalContractor.contractorName}</div>
          </div>
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_surname")}
            </div>
            <div className="font-16">{naturalContractor.contractorSurname}</div>
          </div>
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.email")}
            </div>
            <div className="font-16">{naturalContractor.contractorEmail}</div>
          </div>
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_phone")}
            </div>
            <div className="font-16">
              {naturalContractor.contractorPhone?.formattedPhone
                ? naturalContractor.contractorPhone?.formattedPhone
                : "-"}
            </div>
          </div>
        </div>

        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_residence_province")}
            </div>
            <div className="font-16">
              {naturalContractor.contractorResidenceProvince.value}
            </div>
          </div>
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_residence_municipality")}
            </div>
            <div className="font-16">
              {naturalContractor.contractorResidenceMunicipality.value}
            </div>
          </div>
        </div>
        <div className="d-block d-md-flex mb-3">
          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_residence_address")}
            </div>
            <div className="font-16">
              {naturalContractor.contractorRedisenceAddress}
            </div>
          </div>

          <div className="col-12 col-md-6 mb-4 mb-md-0">
            <div className="font-12-light c-7f7f7f">
              {t("data_entry_step_4.insured_cap")}
            </div>
            <div className="font-16">
              {naturalContractor.contractorNationality === Nationality.IT &&
              naturalContractor.contractorCap
                ? naturalContractor.contractorCap.value
                : "-"}
            </div>
          </div>
        </div>
        {naturalContractor.contractorFc &&
          naturalContractor.contractorFcQuestion === YesNoAnswersNew.YES && (
            <div className="col-12 col-md-6 mb-4 mb-md-0">
              <div className="font-12-light c-7f7f7f">
                {t("data_entry_step_4.insured_fc")}
              </div>
              <div className="font-16">
                {naturalContractor.contractorFc?.toUpperCase()}
              </div>
            </div>
          )}
        {naturalContractor.contractorFcQuestion === YesNoAnswersNew.NO && (
          <div>
            <div className="d-block d-md-flex mb-3">
              {naturalContractor.contractorBirth && (
                <div className="col-12 col-md-6 mb-4 mb-md-0">
                  <div className="font-12-light c-7f7f7f">
                    {t("data_entry_step_4.insured_birth")}
                  </div>
                  <div className="font-16">{naturalContractor.contractorBirth}</div>
                </div>
              )}
              {naturalContractor.contractorBirthNation && (
                <div className="col-5">
                  <div className="font-12-light c-7f7f7f">
                    {t("data_entry_step_4.insured_birth_nation")}
                  </div>
                  <div className="font-16">
                    {naturalContractor.contractorBirthNation}
                  </div>
                </div>
              )}
            </div>
            <div className="d-block d-md-flex mb-3">
              {naturalContractor.contractorBirthPlace && (
                <div className="col-12 col-md-6 mb-4 mb-md-0">
                  <div className="font-12-light c-7f7f7f">
                    {t("data_entry_step_4.insured_birth_place")}
                  </div>
                  <div className="font-16">
                    {naturalContractor.contractorBirthPlace}
                  </div>
                </div>
              )}

              {naturalContractor.contractorBirthProvince && (
                <div className="col-12 col-md-6 mb-4 mb-md-0">
                  <div className="font-12-light c-7f7f7f">
                    {t("data_entry_step_4.insured_birth_province")}
                  </div>
                  <div className="font-16">
                    {naturalContractor.contractorBirthProvince}
                  </div>
                </div>
              )}
            </div>
            <div className="d-block d-md-flex mb-3">
              {naturalContractor.contractorGender && (
                <div className="col-12 col-md-6 mb-4 mb-md-0">
                  <div className="font-12-light c-7f7f7f">
                    {t("data_entry_step_4.insured_gender")}
                  </div>
                  <div className="font-16">
                    {naturalContractor.contractorGender === Gender.M
                      ? t("data_entry_step_4.insured_gender_male")
                      : naturalContractor.contractorGender === Gender.F
                      ? t("data_entry_step_4.insured_gender_female")
                      : ""}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
